function selectOptionFilter(options, filter) {
  return options?.filter((o) => !filter || o.label?.toLowerCase()?.startsWith(filter.toLowerCase()));
}
function doesInclude(a, b) {
  if (Array.isArray(a) && Array.isArray(b)) return b.every((bi) => a.includes(bi));
  return a.indexOf(b) > -1;
}
export {
  doesInclude,
  selectOptionFilter
};
//# sourceMappingURL=utils.js.map
